export type ShopTheme = {
  aftermarketWidget: {
    bgColor: string;
    padding?: number;
  };
  compatibilityWidget: {
    bgColor: string;
    padding?: number;
  };
  partsFinder: {
    bgColor: string;
  };
};

export type PreselectedDataType = {
  brandName?: string;
  year?: string;
  typeName?: string;
  modelId?: string;
  diagramId?: string;
  models?: any;
  diagrams?: any;
  parts?: any;
  ownerManual?: OwnersManualType;
};

export type RidingTypeType = {
  id: string;
  name: string;
};

export type ModelType = {
  id: string;
  name: string;
  year: string;
};

export type DiagramType = {
  id: string;
  category: string;
  title: string;
  file_name: string;
  engine: boolean;
  parts: string;
};

export type PartsType = {
  id: string;
  name: string;
  price: number;
  currency: string;
  replacements?: Record<string, PartsType> | null | string; // is replaced by
  no: string;
  image?: string;
  quantity: string;
  points: string[] | null | undefined;
  replacement?: string; // the part is replacing
  replaced_by?: Object | null; // the part is replaced by
  realtimeData?: RealtimeData;
  aftermarkets?: RealtimeData[];
  powerparts?: RealtimeData[];
  similarOemParts?: RealtimeData[];
  externalStock?: number;
  type?: ProductType;
  imageUrl?: string;
  autoCreateProduct?: boolean; // indicates if a product can be sold even if is not on the website
};

export type DataType = {
  brands: string[];
  years: Record<string, string[]>;
  types: Record<string, RidingTypeType[]>;
  models: Record<string, ModelType[]>;
  diagrams: Record<string, DiagramType[]>;
  parts: Record<string, PartsType[]>;
};

export type ShopifyPriceType = {
  amount: number;
  currencyCode: string;
};

export type ContextualPricing = {
  compareAtPrice?: ShopifyPriceType;
  price: ShopifyPriceType;
};

export type RealtimeData = {
  variantId: string;
  inventoryQuantity: number;
  availableForSale: boolean; // Indicates if the product variant is available for sale.
  inventoryPolicy: "DENY" | "CONTINUE";
  contextualPricing?: ContextualPricing;
  handle: string;
  tags?: string[];
  sku: string;
  title?: string;
  image: string;
  productType: ProductType;

  aftermarketProductDetailUrl?: string; // todo luci: this smells like a hack
};

export enum ProductType {
  SPAREPARTS,
  AFTERMARKET,
  POWERPARTS,
  SIMILAR_OEM_PARTS,
  UNKNOWN,
}

export type PowerpartJsonType = {
  title: string;
  sku: string;
  price: string;
  imageUrl: string;
};

export type PowerpartType = {
  brand: string;
  filename: string;
  title: string;
  sku: string;
  price: number;
  imageUrl: string;
};

export type CompetitorName = "nordicamoto.ro" | "ktmexc.ro" | "moto24.ro";

export type DbCompetitorData = {
  sku: string;
  url: string;
  mainImageUrl?: string;
  currentPrice?: number;
  compareAtPrice?: number;
  recommendedPrice?: number;
  priceCurrency?: string; // RON / EUR etc
  inventoryQuantity: number;
  status: string; // 404, UNAVAILABLE, AVAILABLE, ERROR
  note?: string;
  competitorName: CompetitorName;
};

// define the user model
export type User = {
  email: string;
  token: string;
  shopPermanentDomain: string;
};

export type DbAftermarketOnOem = {
  id: number;
  shop: string;
  oemSku: string;
  aftermarketSku: string;
  title: string | null;
  productUrl: string | null;
  imageUrl: string | null;
  createdAt: Date;
};

export type OwnersManualType = {
  id: String;
  modelId: string;
  url: string;
};

export type RequestQuotePayloadType = {
  sku: string;
  name: string;
};

export type Platform = "shopify" | "prestashop";

export type LegendRowConfigType = {
  label: string;
  color: string;
};

export type CartConfigType = {
  inStockRow?: LegendRowConfigType;
  onRequestRow?: LegendRowConfigType;
  cartInStockColor: string;
  cartOutOfStockColor: string;
  cartExternalStockMessage: string;
  cartExternalStockMessageColor: string;
};

export type ShopEuModelsConfig = {
  showEuModelsToggle: boolean;
  displayEuModelsList: boolean;
};
